import { render } from "./ColumnCarousel.vue?vue&type=template&id=72ee28d3&scoped=true&lang=pug"
import script from "./ColumnCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ColumnCarousel.vue?vue&type=style&index=0&id=72ee28d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ee28d3"]])

export default __exports__